import React from 'react';
import {Props} from './types';
import logoImage from '../logoL.png';

const View: React.FC<Props> = (props: Props) => (
  <div className='bg-gray text-color'>

    {/* Logo */}
    <div className="position-absolute top-0 end-0 p-2">
      <a href="https://linfer-inc.jp/" className="">
        <img src={logoImage} alt="Linfer-L" style={{width: 35}}/>
      </a>
    </div>

    {/* Title */}
    <div className="pt-2 ps-2">
      <h1 className="text-title-color">
        Location Search and Mapping
      </h1>
    </div>

    {/* Form Container */}
    <form className='d-flex flex-column px-4'>
      <div className='d-flex flex-row'>
        {/* Keyword Field */}
        <div className="px-1">
          <label className="text-violet fw-bold text-uppercase">
            Keyword
          </label>
          <input
            className={`form-text`}
            type="text"
            placeholder={'検索'}
            onInput={props.handlers.inputText}
          />
        </div>

        {/* if search type is `Distance` */}
        {props.store.searchType === 'distance' && <>
          {/* Longitude Field */}
          <div className="px-1">
            <label className="fw-bold text-uppercase">
              Longitude
            </label>
            <input
              className={`form-text`}
              type="text"
              placeholder="Click on Map"
              onChange={props.handlers.changeLng}
              value={props.state.inputLng}
            />
          </div>

          {/* Latitude Field */}
          <div className="px-1">
            <label className="fw-bold text-uppercase">
              Latitude
            </label>
            <input
              className={`form-text`}
              type="text"
              placeholder="Click on Map"
              onChange={props.handlers.changeLat}
              value={props.state.inputLat}
            />
          </div>
        </>}

        {props.store.searchType === 'rect' && <>
          <div className="px-1">
            <span className="px-1 fw-bold text-uppercase">Longitude</span>
            <span className={`form-text`}>
              {
                  (props.store.rect.maxLngLat[0] && props.store.rect.minLngLat[0]) ?
                  `${Math.round(props.store.rect.minLngLat[0]*100)/100} ~ ${Math.round(props.store.rect.maxLngLat[0]*100)/100}` :
                  'Draw on Map'
              }
            </span>
          </div>
          <div className="px-1">
            <span className="px-1 fw-bold text-uppercase">Longitude</span>
            <span className={`form-text`}>
              {
                    (props.store.rect.maxLngLat[1] && props.store.rect.minLngLat[1]) ?
                    `${Math.round(props.store.rect.minLngLat[1]*100)/100} ~ ${Math.round(props.store.rect.maxLngLat[1]*100)/100}` :
                    'Draw on Map'
              }
            </span>
          </div>
        </>}

        {/* Search Button */}
        <div className="d-flex align-items-end">
          <button
            className="btn-plane-yellow"
            type="button"
            onClick={props.handlers.search}
          >
              Search
          </button>
        </div>
      </div>

      {/* Select Search Type Feild */}
      <div className="d-flex justify-content-center py-2">
        <div className='form-check'>
          <input
            className="form-check-input"
            type="checkbox"
            checked={props.store.searchType == 'distance'}
            onChange={() => props.handlers.switchSearchType('distance')}
            id="distance"
          />
          <label
            className="form-check-label text-violet fw-bold"
            htmlFor="distance"
          >
            Sort by Distance from Location
          </label>
        </div>

        <div className='form-check'>
          <input
            className="form-check-input"
            type="checkbox"
            checked={props.store.searchType == 'rect'}
            onChange={() => props.handlers.switchSearchType('rect')}
            id="rect"
          />
          <label
            className="form-check-label text-violet fw-bold"
            htmlFor="rect"
          >
            Filter by Rectangle on Map
          </label>
        </div>
      </div>
    </form>
  </div>
);

export default View;
